<template>
  <div class="main">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            工单信息
          </div>
        </template>
        <div class="collapse-content">
          <MessageForm :query="query"></MessageForm>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            维修项目
          </div>
        </template>
        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="settleAccountsRef"
            class="vxe-table-element"
            size="mini"
            align="center"
            :auto-resize="true"
            :edit-rules="tableRules"
            :edit-config="{ trigger: 'click', mode: 'row' }"
            :data="tableData"
            :valid-config="{ autoPos: true, message: 'inline' }"
            @select-change="handleSelectionChange"
            @select-all="handleSelectionChange"
            @edit-closed="closeEditTableHandler"
            height="200"
          >
            <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
            <vxe-table-column
              v-for="(item, index) in columnListDefault"
              :key="index"
              :type="item.type"
              :fixed="item.fixed"
              :field="item.field"
              :title="item.title"
              :width="item.width"
              :sortable="item.sortable"
              :edit-render="item.editRender"
            >
              <template v-slot:edit="{ row }">
                <!--数字输入框--显示2位-->
                <inputNumberAd
                  v-model="row['actualCost']"
                  v-if="item.editRender.name == 'inputCost'"
                  :controls="false"
                  class="inputWidth"
                  :precision="2"
                  :min="0"
                  :max="99999999999999999"
                ></inputNumberAd>
                <el-date-picker
                  v-else-if="item.editRender.name == 'datePicker'"
                  style="width: 100%"
                  v-model="row[item.field]"
                  type="date"
                  clearable
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </template>
            </vxe-table-column>
          </vxe-grid>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :fileType="fileType"
            :limitFileCount="10"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <footer class="text-center">
      <div style="padding: 10px; background: #fff">
        <el-row class="page-row">
          <el-button type="primary" @click="confirmClick">确认完工</el-button>
          <el-button type="primary" @click="cancelClick" plain>取消</el-button>
        </el-row>
      </div>
    </footer>
  </div>
</template>

<script>
  import MessageForm from '../components/MessageForm.vue';
  import { columnListDefault } from './index.js';
  import { tableRules } from './rule.js';
  import API from '@/api/property/workorder.js';
  import mixin from './../mixin';
  import btnMixins from './../btnMixins.js';
  export default {
    name: 'workorderDetail',
    mixins: [mixin, btnMixins],
    data() {
      return {
        activeNames: ['1', '2', '3', '4'],
        attachments: [],
        input: '',
        load: false,
        tableData: [],
        // 表格
        columnListDefault: columnListDefault,
        tableRules: tableRules,
        query: {
          workOrderCompanyNo: '',
          name: '',
          dispatchPersonName: '',
          workOrderDepartmentNo: '',
          relatedRepairFlag: '',
          repairNo: '',
          receivePersonName: '',
          contactPhone: '',
        },
        // 附件相关
        fileTableSelection: [],
        fileType: ['xls', 'xlsx', 'txt', 'doc', 'docx', 'pdf', 'jpg'],
        fileSelectionList: [], //选中文件行
      };
    },
    mounted() {
      let { id } = this.$route.query;
      this.getDetail(id);
    },
    methods: {
      // 获取详情信息
      async getDetail(id) {
        let { data } = await this.$axios.post(`${API.WORKORDER_DETAIL}/${id}`);
        if (data.code == 0) {
          this.query = this.translateFiled(data.data, 'workOrderDTO');
          console.log('query', this.query);
          this.tableData = this.translateFiled(
            data.data.workOrderProjectVOList,
            'workOrderProjectVOList'
          );
        }
      },
      handleSelectionChange() {},
      handleChange(row, prop) {
        console.log('input输入框', row, prop);
      },
      // 确认完工
      confirmClick() {
        this.$confirm('是否确认完工', '提示')
          .then(() => {
            this.getSubmitData();
          })
          .catch(() => {
            console.log('取消');
          });
      },
      // 获取需要提交的数据
      async getSubmitData() {
        let attachments = this.$refs.fileTableRef.getTableData();
        let workOrderDTO = {
          id: this.query.id,
        };
        if (attachments.length) {
          workOrderDTO.workOrderNo = this.query.workOrderNo;
        }
        workOrderDTO.attachments = attachments;
        console.log('workOrderDTO', workOrderDTO);
        let workOrderProjectDTOList = '';
        await this.getValidateTableData().then((res) => {
          console.log('res', res);
          workOrderProjectDTOList = res.tableData.map((item) => {
            return {
              companyCode: this.userInfo.companyCode,
              companyName: this.userInfo.companyName,
              departmentCode: this.userInfo.departmentCode,
              departmentName: this.userInfo.departmentName,
              ...item,
            };
          });
        });
        this.loading.startLoading();
        let { data } = await this.$axios.post(API.CONFIRM_WORKORDER_COMPLETE, {
          checkFlag: false,
          dispatchFlag: false,
          workOrderDTO,
          workOrderProjectDTOList,
        });
        this.loading.endLoading();
        if (data.code == 0) {
          this.$message.success(data.msg);
          this.$store.dispatch('tagsView/delView', this.fromPath).then(() => {
            this.$nextTick(() => {
              this.$router.push(this.path);
            });
          });
        } else {
          this.$message.error(data.msg);
        }
      },
    },
    components: { MessageForm },
  };
</script>

<style scoped></style>
